// src/components/SubscriptionDebugPanel.jsx
import React, { useState } from 'react';

const SpinnerIcon = () => (
  <svg className="animate-spin h-4 w-4 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
);

const DebugPanel = ({ 
  isTrialMode, 
  setIsTrialMode, 
  trialDays, 
  setTrialDays, 
  handlePremiumDaily, 
  loadingDaily 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Only render in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      {isExpanded ? (
        <div className="bg-gray-800 text-white p-3 rounded-lg shadow-lg">
          <div className="flex flex-col space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium">Debug Panel</span>
              <button 
                onClick={() => setIsExpanded(false)}
                className="text-gray-400 hover:text-white"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
              <div className="flex items-center space-x-2">
                <button 
                  className="px-3 py-1 text-xs rounded bg-orange-600 text-white flex items-center justify-center hover:bg-orange-700"
                  onClick={handlePremiumDaily}
                  disabled={loadingDaily}
                >
                  Premium Daily
                  {loadingDaily && <SpinnerIcon />}
                </button>
              </div>
              
              <div className="flex items-center space-x-1">
                <span className="text-xs text-gray-300">Trial:</span>
                <button 
                  className={`px-2 py-1 text-xs rounded ${!isTrialMode ? 'bg-green-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}
                  onClick={() => {setIsTrialMode(false); setTrialDays(0);}}
                >
                  Off
                </button>
                <button 
                  className={`px-2 py-1 text-xs rounded ${isTrialMode && trialDays === 1 ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}
                  onClick={() => {setIsTrialMode(true); setTrialDays(1);}}
                >
                  1 Day
                </button>
                <button 
                  className={`px-2 py-1 text-xs rounded ${isTrialMode && trialDays === 14 ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}
                  onClick={() => {setIsTrialMode(true); setTrialDays(14);}}
                >
                  14 Days
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <button 
          onClick={() => setIsExpanded(true)}
          className="bg-gray-800 text-white p-2 rounded-full shadow-lg hover:bg-gray-700"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6V12M12 12V18M12 12H18M12 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default DebugPanel;